import React from 'react';
import { motion } from 'framer-motion';
import { DollarSignIcon, PhoneOffIcon, UsersIcon } from 'lucide-react';
import { CTARow } from './CTARow';
export function MissedCallsSection() {
  const stats = [{
    icon: DollarSignIcon,
    text: 'Missed calls cost small businesses tens of thousands of dollars per year.',
    delay: 0.1
  }, {
    icon: PhoneOffIcon,
    text: "80–85% of callers who don't get through will never call back or leave a voicemail.",
    delay: 0.2
  }, {
    icon: UsersIcon,
    text: 'More than half of those callers go directly to a competitor after a bad or no-answer experience.',
    delay: 0.3
  }];
  return <section className="py-20 bg-gray-50" data-id="element-105">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-106">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-107">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-108">
            Missed Calls Are Quietly Killing Your Revenue.
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-gray-600" data-id="element-109">
            Every time your phone rings and goes to voicemail, you're not just
            missing a conversation—you're handing a potential customer directly
            to your competition.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-110">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: stat.delay
        }} className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow border border-gray-100" data-id="element-111">
              <div className="w-14 h-14 bg-viridia-50 rounded-full flex items-center justify-center mb-6 mx-auto" data-id="element-112">
                <stat.icon className="w-7 h-7 text-viridia-600" data-id="element-113" />
              </div>
              <p className="text-gray-800 font-medium text-center leading-relaxed" data-id="element-114">
                {stat.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-115">
          <p className="text-xl font-bold text-gray-900 mb-8 border-b-2 border-viridia-200 inline-block pb-1" data-id="element-116">
            Your phone should not be a leak in your pipeline.
          </p>
          <CTARow align="center" data-id="element-117" />
        </motion.div>
      </div>
    </section>;
}